import React from "react";
import { ReactComponent as HeroImage } from '../images/undraw_launching_szjw.svg';


const Hero = () => {
    return (
      <div data-theme={"dark"} className="hero rounded-b-3xl bg-blue-600 shadow-inner min-h-screen overflow-hidden">
        {/*grid layout*/}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2 items-center max-w-7xl w-full min-h-screen z-10">

          {/* Left grid */}
          <div className="relative flex flex-col justify-center items-center md:items-start text-center md:text-left px-4">

            {/* TEXT */}
            <div className="max-w-md z-10">
              <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold leading-tight md:leading-snug lg:leading-[1.2]">
                We Help Scale Your <span className="bg-yellow-300 text-black px-1 rounded">Business.</span>
              </h1>
              <p className="py-6 text-base">
              Digiscape helps businesses across the GTA grow with stunning websites, targeted online marketing, and reliable IT services — all at unbeatable local rates.
              </p>
              <button className="btn rounded-2xl bg-blue-200 text-gray-800"><a href="#cta">Get FREE Quote</a></button>
            </div>
          </div>

          {/*right grid*/}
          <div className="relative hidden [@media(min-width:1085px)]:flex justify-center">
            {/* SVG */}
            <HeroImage className="w-64 md:w-[1800px] lg:w-[40000px] h-auto z-10 right-15" />
            
            {/* background blobs */}
            <div className="absolute top-[-200px] left-[-100px] w-[800px] h-[800px] -z-10 opacity-30">
              <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
                <path
                  fill="#55efc4"
                  d="M52,-63.9C67.5,-60.2,80.3,-45.2,82.6,-29C84.9,-12.7,76.8,4.8,66.9,17.5C57,30.3,45.3,38.2,33.8,47.6C22.4,56.9,11.2,67.5,-4.2,73.3C-19.5,79,-39.1,79.9,-54.3,71.8C-69.5,63.7,-80.4,46.7,-86.3,28.2C-92.1,9.7,-92.8,-10.4,-84.3,-24.5C-75.7,-38.6,-57.8,-46.7,-42.2,-50.3C-26.6,-53.9,-13.3,-52.9,2.5,-56.3C18.2,-59.7,36.4,-67.5,52,-63.9Z"
                  transform="translate(100 100)"
                />
              </svg>
            </div>
            <div className="absolute top-[-200px] left-[-100px] w-[800px] h-[800px] -z-10 opacity-30">
              <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
                <path fill="#81ECEC" d="M38,-48.3C52.5,-41.8,69.7,-35,72.7,-24.1C75.6,-13.1,64.3,2.1,58.6,18.8C52.8,35.4,52.5,53.6,43.6,60.6C34.8,67.6,17.4,63.4,3.2,59C-11,54.5,-21.9,49.9,-32.4,43.4C-42.9,37,-52.9,28.7,-62.6,16.2C-72.2,3.8,-81.6,-12.9,-80.2,-28.8C-78.8,-44.7,-66.7,-59.9,-51.5,-66.2C-36.3,-72.5,-18.2,-70,-3.2,-65.6C11.8,-61.2,23.5,-54.9,38,-48.3Z" transform="translate(100 100)" />
              </svg>
            </div>
            <div className="absolute top-[-150px] left-[-50px] w-[800px] h-[800px] -z-10 opacity-20">
              <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
                <path fill="white" d="M43.6,-55.4C57,-50.2,68.7,-38.2,69.3,-25.2C69.9,-12.1,59.4,1.9,55,18.6C50.6,35.4,52.3,54.9,44.2,66.5C36.1,78.1,18,81.7,3.7,76.7C-10.6,71.6,-21.3,57.8,-34.5,47.8C-47.6,37.9,-63.3,31.8,-68.6,21C-73.9,10.2,-68.7,-5.2,-62.7,-19.4C-56.7,-33.5,-49.9,-46.4,-39.3,-52.4C-28.7,-58.5,-14.3,-57.8,0.4,-58.3C15.1,-58.8,30.2,-60.5,43.6,-55.4Z" transform="translate(100 100)" />
              </svg>
            </div>

          </div>
        </div>   
      </div>
    );
};

export default Hero;